import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export function HelpModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-gray-200 text-black max-w-md rounded-lg" data-testid="help-modal">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-center text-black">How To Play</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 text-sm text-gray-700">
          <p>Guess the Wordle in 6 tries.</p>
          
          <ul className="list-disc pl-5 space-y-1">
            <li>Each guess must be a valid 5-letter word.</li>
            <li>The color of the tiles will change to show how close your guess was to the word.</li>
          </ul>
          
          <div className="border-t border-gray-200 pt-4">
            <p className="font-bold mb-3">Examples</p>
            
            <div className="space-y-4">
              <div>
                <div className="flex gap-1 mb-2">
                  <div className="w-10 h-10 bg-[#6aaa64] border-2 border-[#6aaa64] flex items-center justify-center font-bold text-white">W</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">E</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">A</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">R</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">Y</div>
                </div>
                <p><strong>W</strong> is in the word and in the correct spot.</p>
              </div>
              
              <div>
                <div className="flex gap-1 mb-2">
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">P</div>
                  <div className="w-10 h-10 bg-[#c9b458] border-2 border-[#c9b458] flex items-center justify-center font-bold text-white">I</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">L</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">L</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">S</div>
                </div>
                <p><strong>I</strong> is in the word but in the wrong spot.</p>
              </div>
              
              <div>
                <div className="flex gap-1 mb-2">
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">V</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">A</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">G</div>
                  <div className="w-10 h-10 bg-[#787c7e] border-2 border-[#787c7e] flex items-center justify-center font-bold text-white">U</div>
                  <div className="w-10 h-10 border-2 border-[#d3d6da] flex items-center justify-center font-bold">E</div>
                </div>
                <p><strong>U</strong> is not in the word in any spot.</p>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-200 pt-4">
            <p className="font-bold text-black">Chain Rule</p>
            <p className="mt-2">Solve in 4 guesses or less to unlock the next word. Complete all 5 words to win the day!</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
